/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Club_Target_InvalidInputs */

const en_us2_club_target_invalid = /** @type {(inputs: Club_Target_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The goal goes from 1 to 100.`)
};

const pt_br2_club_target_invalid = /** @type {(inputs: Club_Target_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A meta vai de 1 a 100.`)
};

const es_419_club_target_invalid = /** @type {(inputs: Club_Target_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La meta va de 1 a 100.`)
};

const pt_pt2_club_target_invalid = /** @type {(inputs: Club_Target_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O objetivo vai de 1 a 100.`)
};

const fr_fr2_club_target_invalid = /** @type {(inputs: Club_Target_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'objectif va de 1 à 100.`)
};

const de_de2_club_target_invalid = /** @type {(inputs: Club_Target_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ziel liegt zwischen 1 und 100.`)
};

const it_it2_club_target_invalid = /** @type {(inputs: Club_Target_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'obiettivo va da 1 a 100.`)
};

/**
* | output |
* | --- |
* | "The goal goes from 1 to 100." |
*
* @param {Club_Target_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const club_target_invalid = /** @type {((inputs?: Club_Target_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Club_Target_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_club_target_invalid(inputs)
	if (locale === "es-419") return es_419_club_target_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_club_target_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_club_target_invalid(inputs)
	if (locale === "de-DE") return de_de2_club_target_invalid(inputs)
	if (locale === "it-IT") return it_it2_club_target_invalid(inputs)
	return en_us2_club_target_invalid(inputs)
});
export { club_target_invalid as "club.target_invalid" }